
import apiClient from '../../../services/apiClient';

const compactParams = (params = {}) =>
  Object.fromEntries(
    Object.entries(params).filter(
      ([, value]) =>
        value !== undefined &&
        value !== null &&
        value !== '',
    ),
  );

export const unwrapStaffData = (payload) =>
  payload?.data ?? payload;

export const staffApi = {
  getStaff: async (schoolId, params = {}) => {
    const response = await apiClient.get(
      `/schools/${schoolId}/staff/`,
      {
        params: compactParams({
          page: params.page ?? 1,
          page_size: params.page_size,
          q: params.q,
          staff_type: params.staff_type,
          department: params.department,
          designation: params.designation,
          login_status: params.login_status,
          status: params.status,
        }),
      },
    );

    return response.data;
  },

  getDashboardSummary: async (schoolId, params = {}) => {
    const response = await apiClient.get(
      `/schools/${schoolId}/dashboard/`,
      {
        params: compactParams({
          academic_year_id:
            params.academicYearId ?? params.academic_year_id,
        }),
      },
    );
    return response.data;
  },

  createStaff: async (schoolId, staffData) => {
    const response = await apiClient.post(
      `/schools/${schoolId}/staff/`,
      staffData,
    );
    return response.data;
  },

  getStaffById: async (schoolId, staffId) => {
    const response = await apiClient.get(
      `/schools/${schoolId}/staff/${staffId}/`,
    );
    return response.data;
  },

  updateStaff: async (schoolId, staffId, staffData) => {
    const response = await apiClient.patch(
      `/schools/${schoolId}/staff/${staffId}/update/`,
      staffData,
    );
    return response.data;
  },

  updateStaffStatus: async (schoolId, staffId, status) => {
    const response = await apiClient.patch(
      `/schools/${schoolId}/staff/${staffId}/status/`,
      { status },
    );
    return response.data;
  },

  assignClassTeacher: async (
    schoolId,
    staffId,
    assignmentData,
  ) => {
    const response = await apiClient.post(
      `/schools/${schoolId}/staff/${staffId}/assignments/class-teacher/`,
      assignmentData,
    );
    return response.data;
  },

  assignSubject: async (
    schoolId,
    staffId,
    assignmentData,
  ) => {
    const response = await apiClient.post(
      `/schools/${schoolId}/staff/${staffId}/assignments/subject/`,
      assignmentData,
    );
    return response.data;
  },

  uploadStaffDocument: async (
    schoolId,
    staffId,
    documentData,
  ) => {
    const response = await apiClient.post(
      `/schools/${schoolId}/staff/${staffId}/documents/upload/`,
      documentData,
    );
    return response.data;
  },

  toggleLoginAccess: async (
    schoolId,
    staffId,
    enableLogin,
    options = {},
  ) => {
    const response = await apiClient.patch(
      `/schools/${schoolId}/staff/${staffId}/toggle-login/`,
      {
        enable_login: Boolean(enableLogin),
        role_ids: options.roleIds,
        send_activation_email:
          options.sendActivationEmail ?? true,
      },
    );
    return response.data;
  },

  resendActivationEmail: async (schoolId, staffId) => {
    const response = await apiClient.post(
      `/schools/${schoolId}/staff/${staffId}/resend-activation/`,
    );
    return response.data;
  },
};

export default staffApi;
